import { Box, styled, Typography } from '@mui/material';

export const CardContainer = styled(Box)(({ theme }) => ({
  width: '228px',
  height: '160px',
  border: `solid 1px ${theme.palette.colors.borderLine}`,
  backgroundColor: theme.palette.colors.secondaryBackground,
  padding: '12px',
  borderRadius: '12px',
  flexShrink: 0,
}));

export const TopContainer = styled(Box)(() => ({
  height: '60%',
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
}));

export const InfoAndChartContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflow: 'hidden',
}));

export const Description = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 'bold',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
}));

export const Symbol = styled(Typography)(({ theme }) => ({
  fontSize: '10px',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  marginBottom: '8px',
}));

export const VariationAndChartContainer = styled(Typography)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
}));

export const BottomContainer = styled(Box)(() => ({
  height: '40%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
}));

export const LastPx = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 'bold',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));

export const DateLabel = styled(Typography)(({ theme }) => ({
  fontSize: '10px',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));

export const TimeLabel = styled(Typography)(({ theme }) => ({
  fontSize: '10px',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));

export const ButtonsContainer = styled(Typography)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
}));
